import { render, staticRenderFns } from "./rolepermission.vue?vue&type=template&id=1072d966&"
import script from "./rolepermission.vue?vue&type=script&lang=js&"
export * from "./rolepermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports